export default function JsonLd({
  description,
  isPartOf,
  title,
  canonical,
  OgImageUrl,
  BreadcrumbListJson,
  FAQ,
}) {
  const categoryPageJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      FAQ ? FAQ : "",
      // website
      {
        "@type": "WebSite",
        "@id": "https://quicktor.co.il/#website",
        url: "https://quicktor.co.il/",
        name: "QuickTor",
        description:
          "QuickTor - נהלו תורים בקלות עם מערכת חכמה הכוללת הודעות וואטסאפ, תשלום מראש על תור וזימון תורים אונליין. פתרון All-in-One לניהול העסק שלך. התחל עכשיו!",
        potentialAction: [
          {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://quicktor.co.il/?s={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        ],
        inLanguage: "he-IL",
      },
      // webpage
      {
        "@type": "WebPage",
        "@id": canonical,
        url: canonical,
        name: title,
        isPartOf: {
          "@id": isPartOf,
        },
        primaryImageOfPage: {
          "@id": OgImageUrl,
        },
        image: {
          "@id": OgImageUrl,
        },
        thumbnailUrl: OgImageUrl,
        description: description,
        breadcrumb: {
          "@id": canonical,
        },
        inLanguage: "he-IL",
        potentialAction: [
          {
            "@type": "ReadAction",
            target: [canonical],
          },
        ],
      },
      // ImageObject
      {
        "@type": "ImageObject",
        inLanguage: "he-IL",
        "@id": OgImageUrl,
        url: OgImageUrl,
        contentUrl: canonical,
        width: 1800,
        height: 1800,
      },
      // Organization
      {
        "@type": "Organization",
        "@id": "https://quicktor.co.il/#organization",
        name: "QuickTor אפליקציה לניהול תורים, תזכורות חכמות, סליקה וזימון תורים",
        url: "https://quicktor.co.il/",
        logo: {
          "@type": "ImageObject",
          inLanguage: "he-IL",
          "@id": "/logo-no-background_jbdvus.png",
          url: "/logo-no-background_jbdvus.png",
          contentUrl: "/logo-no-background_jbdvus.png",
          width: 294,
          height: 111,
          caption: "QuickTor Queue management Logo",
        },
        // "QuickTor אפליקציה לניהול תורים, תזכורות חכמות, סליקה וזימון תורים",
      },
      // BreadcrumbList
      {
        "@type": "BreadcrumbList",
        description: "Breadcrumbs list",
        "@id": canonical,
        itemListElement: BreadcrumbListJson,
      },
    ],
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(categoryPageJsonLd) }}
    />
  );
}
